import { result } from 'lodash';
import APIClient from '../../../../common/services/APIClient';
import dictionariesTypesEnum from '../../../../common/constants/dictionaries';
import { initDictionaryList } from '../../../AdminTools/components/Dictionary/actions';

export const initCountries = () => (dispatch) => {
  APIClient.get(`/dictionaries/${dictionariesTypesEnum.country}`, { params: { page_token: 0, page_size: 999 } })
    .then((resp) => {
      const payloads = result(resp, 'data.payloads', []);
      const size = result(resp, 'data.total_size', 0);

      dispatch(initDictionaryList(dictionariesTypesEnum.country, {
        dictionary: payloads,
        total_size: size,
      }));
    })
    .catch(() => {
      dispatch(initDictionaryList(dictionariesTypesEnum.country, []));
    });
};
